<template>
  <div id="mainDiv">
    <!-- -------------------------------------- MENU ------------------------------------------ -->

    <MenuView></MenuView>

    <!-- -------------------------------------- IMAGEN 1 ------------------------------------------ -->

    <WelcomeView></WelcomeView>

    <!-- -------------------------------------- IMAGEN 2 ------------------------------------------ -->

    <AboutView></AboutView>

  
    <!-- -------------------------------------- IMAGEN 4 ------------------------------------------ -->

    <CardView></CardView>

    <!-- -------------------------------------- IMAGEN 5 ------------------------------------------ -->

    <Everybody></Everybody>

    <!-- -------------------------------------- IMAGEN 7 ------------------------------------------ -->

    <SolutionsView></SolutionsView>

    <!-- -------------------------------------- IMAGEN 8 ------------------------------------------ -->

    <UbicationView></UbicationView>

    <!-- -------------------------------------- BOTÓN WHATSAPP FLOTANTE ------------------------------------------ -->
    <a
      href="https://wa.me/573013170482?text=Buen%20d%C3%ADa%20me%20gustar%C3%ADa%20tener%20informaci%C3%B3n"
      target="_blank"
      rel="noreferrer"
      class="whatsapp-btn"
      aria-label="Contactar por WhatsApp"
      title="Contactar por WhatsApp"
    >
      <i class="bi bi-whatsapp"></i>
    </a>
</div>
    
</template>

<script>
import MenuView from "@/views/MenuView.vue";
import WelcomeView from "@/views/WelcomeView.vue";
import AboutView from "@/views/AboutView.vue";
import CardView from "@/views/CardView.vue";
import Everybody from "@/views/EverybodyView.vue";
import SolutionsView from "@/views/SolutionsView.vue";
import UbicationView from "@/views/UbicationView.vue";

export default {
  name: "tess",
  components: {
    MenuView,
    WelcomeView,
    AboutView,
    CardView,
    Everybody,
    SolutionsView,
    UbicationView
  },
  props: {},
  data() {
    return {
    };
  },
  methods: {
   
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#mainDiv {
  overflow-x: hidden;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  position: relative;
}

/* ===== Botón WhatsApp Flotante ===== */
.whatsapp-btn {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 60px;
  height: 60px;
  background: #25D366;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 32px;
  z-index: 999;
  box-shadow: 0 10px 30px rgba(37, 211, 102, 0.4);
  transition: transform 200ms ease, box-shadow 200ms ease;
  text-decoration: none;
}

.whatsapp-btn:hover {
  transform: scale(1.1) translateY(-3px);
  box-shadow: 0 15px 40px rgba(37, 211, 102, 0.6);
}

.whatsapp-btn i {
  line-height: 1;
}

/* ===== Responsive ===== */
@media (max-width: 768px) {
  .whatsapp-btn {
    bottom: 20px;
    right: 20px;
    width: 55px;
    height: 55px;
    font-size: 28px;
  }
}

.text-overlay {
  position: absolute;
  top: 35%;
  text-align: center;
}

.text-overlay h2 {
  color: #edf0f1;
  font-family: "Barlow", sans-serif;
  font-size: 6vw;
  font-weight: 600;
}

.text-overlay h1 {
  color: #76caff;
  font-family: "Barlow", sans-serif;
  font-size: 10vw;
  font-weight: 600;
  margin-left: 50px;
}

.text-overlay h4 {
  font-family: "Barlow", sans-serif;
  color: #edf0f1;
  font-weight: 300;
}
</style>
